import { FC } from 'react'
import { Input } from 'src/components/input'

type ValidatorRef = { validationType: string; value: Record<string, unknown> }

interface NumberInputFieldProps {
  value?: string | null
  disabled?: boolean
  handleResponse: (value: string) => void
  // Props below exist for interface consistency with other field types
  variant?: string
  handleSearch?: (value: string) => void
  options?: unknown[]
  loading?: boolean
  isMultiple?: boolean
  numPad?: boolean
  questionDisplay?: string | null
  valueRef?: unknown
  validatorsRef?: ValidatorRef[]
  patternError?: string | null
  onPatternError?: (error: string | null) => void
}

const NumberInputField: FC<NumberInputFieldProps> = ({
  handleResponse,
  value,
  disabled = false,
  patternError,
}) => {
  const inputValue = value === null || value === undefined ? '' : value

  // Validation and branching are driven by the server; this field only renders
  // the input and any server-provided error passed via `patternError`.
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleResponse(e.target.value)
  }

  return (
    <div>
      <Input type="number" disabled={disabled} value={inputValue} onChange={handleChange} />
      {patternError && <p className="mt-1 text-sm text-error">{patternError}</p>}
    </div>
  )
}

export default NumberInputField
